import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";
export const getUnreadApplication =  async (queryParams:any) => {
  try {
  return await get<ApiResponse<[]>>(`/application/unread?${queryParams}`).then((res)=>{
    if(res?.success===true){
        return res
    }
    else {
      return null
    }
  })
}
catch(e){
HandleApiError(e)
}
};
